import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import { getBrandTermCondition } from "../../../services/BrandTermAndCondition/BrandTermAndCondition";
import AdminMenu from "../../AdminMenu";

const BrandTermAndCondition = () => {
  const navigate = useNavigate();
  const [garmentPackData, setGarmentPackData] = useState([]);
  const [visible, setVisible] = useState(false);

  const {brandProfileData } = getUserData();
  let brandId = brandProfileData.id;
  const [loading, setLoading] = useState(false);

  const fetchGarmentPack = () => {
    setLoading(true);
    getBrandTermCondition(brandId)
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;
          setGarmentPackData(res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchGarmentPack();
  }, []);

  const renderCardItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Term & Condition :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.termCondition}
                  </p>
                </div>

                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Status:
                    </p>

                    {item.status === true ? (
                      <div className="flex">
                        <p className="text-lg font-medium capitalize">
                          Active{" "}
                        </p>
                        <img
                          src={
                            "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                          }
                        />
                      </div>
                    ) : (
                      <div className="flex">
                        <p className="text-lg font-medium capitalize">
                          DeActive{" "}
                        </p>
                        <img
                          src={
                            "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div
                    className="mr-4 mt-2"
                    onClick={() =>
                      navigate("/BrandTermAndConditionCreate", {
                        state: {
                          item: item,
                        },
                      })
                    }
                  >
                    <i
                      className="pi pi-pencil"
                      style={{
                        fontSize: "25px",
                        cursor: "pointer",
                        color: "#2B70D7",
                      }}
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
              Brand Term & Condition
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div
          className="flex-1  surface-0"
          style={{ "--surface-0": "#EAEFF5" }}
        >
          <div className="flex justify-content-between mx-4">
            <div className="py-1">
              <p className=" text-2xl  font-bold ">Brand Term & Condition</p>
            </div>
            <div
              className="flex justify-content-center align-items-center cursor-pointer mr-4"
              onClick={() => {
                navigate("/BrandTermAndConditionCreate", {
                  state: {
                    id: null,
                  },
                });
              }}
            >
              <img src="images/plus.png" alt="plus" style={{ width: 30 }} />
            </div>
          </div>
        </div>
      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : garmentPackData?.length > 0 ? (
          <div>
            <div>{renderCardItem(garmentPackData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Brand Term & Condition Found</p>
          </div>
        )}
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default BrandTermAndCondition;
